import { Box, Button, Card, Modal, Stack, Typography } from "@mui/material";
import React from "react";

export default function LeadStatusDescriptionViewModal({
  leadStatusData,
  leadStatusDescriptionViewModal,
  setLeadStatusDescriptionViewModal
}) {
  const leadStatusDescriptionModalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 500,
    bgcolor: "background.paper",
    boxShadow: 10,
    borderRadius: "10px",
    p: 2
  };

  return (
    <Modal
      open={leadStatusDescriptionViewModal}
      onClose={() => setLeadStatusDescriptionViewModal(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={leadStatusDescriptionModalStyle}>
        <Typography
          id="modal-modal-title"
          variant="h6"
          textAlign="center"
          style={{ marginBottom: "10px" }}
        >
          ({leadStatusData?.name}) Description
        </Typography>
        <hr />
        <Card style={{ marginTop: "15px", maxHeight: "400px", overflow: "scroll", width: "100%" }}>
          <Typography variant="body1" style={{ padding: "10px" }}>
            {leadStatusData?.description || "No description available."}
          </Typography>
        </Card>
        <Stack direction="row" spacing={2} justifyContent="end" mt={2}>
          <Button variant="outlined" onClick={() => setLeadStatusDescriptionViewModal(false)}>
            Close
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
}
